import * as Yup from "yup";
export const validationSchema = Yup.object().shape({
    rating: Yup.number().required("هذا الحقل مطلوب"),
    comment: Yup.string().trim("لايمكن ان يحوي رفراغات"),
});
export const formikProps = {
    validationSchema,
    formik: {
        onChangeValidate: false,
        onBlurValidate: false,
    },
    initialValues: {
        rating: 5,
        comment: '',
    },
};
